import React, { useState } from "react";
import { useLocation, useOutletContext } from "react-router";
import { tileSize } from "../../../utils/tileSizes";
import { tileTypes } from "../../../utils/tileTypes";
import TickIcon from "../SvgIcons/ManageIcons/TickIcon";
import classes from "./Tile.module.scss";
import RoleMenuChek from "../../../hoc/RoleMenuCheck";
import CountUp from "react-countup";
import { createPasscode } from "../../../utils/mainTabs/events/createPasscode";

const Tile = ({
  value,
  label,
  stripeColor = JSON.parse(localStorage.getItem("themeData")).CustomData
    .PrimaryColor1,
  defaultTileicon,
  smallTileIcon,
  onClick,
  isCompleted = false, //For step tiles
  size,
  type,
  width,
  path,
  isHover = true,
  isVisible = true,
  name,
  feature,
}) => {
  const [hoverState, sethoverState] = useState(false);
  const primaryColor = JSON.parse(localStorage.getItem("themeData")).CustomData
    .PrimaryColor1;
  const whiteColor = "#ffffff";
  const location = useLocation();
  const { tenantName } = useOutletContext();
  const createPasscodePath = createPasscode.path(tenantName);
  const isNumber = typeof value === 'number';
  return (
    <RoleMenuChek type={name} feature={feature}>
      <div
        className={classes.normalTile}
        style={{
          width: width ? width : "100%",
          background:
            hoverState || location.pathname === path
              ? primaryColor
              : whiteColor,
          cursor: onClick ? "pointer" : "auto",
          display: isVisible ? "block" : "none",
        }}
        onMouseEnter={() => {
          if (!isCompleted && isHover) sethoverState(true);
        }}
        onMouseLeave={() => {
          if (!isCompleted && isHover) sethoverState(false);
        }}
        onClick={onClick}
      >
        <div
          className={
            type === tileTypes.SMALL ? classes.topStripe : classes.centerStripe
          }
          style={{
            backgroundColor:
              hoverState || location.pathname === path
                ? whiteColor
                : stripeColor,
            height: size === tileSize.EXTRA_SMALL ? "3.3rem" : "4.6rem",
          }}
        ></div>
        <div
          className={classes.tileIcon}
          style={{
            color:
              hoverState || location.pathname === path ? whiteColor : "#707070",
          }}
        >
          {defaultTileicon &&
            defaultTileicon(
              hoverState || location.pathname === path
                ? whiteColor
                : stripeColor
            )}
        </div>
        {isCompleted && (
          <div className={classes.tickIcon}>
            <TickIcon fill="#43E57A" />
          </div>
        )}
        <div className={classes.header}>
          {smallTileIcon ? (
            smallTileIcon(
              hoverState || location.pathname === path
                ? whiteColor
                : stripeColor
            )
          ) : (
            <p
              className={classes.label}
              style={{
                color:
                  hoverState || location.pathname === path
                    ? whiteColor
                    : primaryColor,
              }}
            >
              {!location.pathname.includes(createPasscodePath) && (
                isNumber ? (
                  <CountUp start={0} end={value} />
                ) : (
                  <span>{value}</span>
                )
              )}
              {/* {value} */}
            </p>
          )}
          <p
            className={classes.descriptionText}
            style={{
              color:
                hoverState || location.pathname === path
                  ? whiteColor
                  : "#404040",
            }}
          >
            {label}
          </p>
        </div>
      </div>
    </RoleMenuChek>
  );
};

export default Tile;
